import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import ProgramSwitcherStore from 'bundles/enterprise-legacy-learner-home/stores/ProgramSwitcherStore';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ProfileStore from 'bundles/profile/stores/ProfileStore';
import component from 'bundles/program-skills-objectives/routes';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

const appEnv = new Fluxible({
  component,
});

appEnv.registerStore(ApplicationStore);
appEnv.registerStore(NaptimeStore);
appEnv.registerStore(ProgramSwitcherStore);
appEnv.registerStore(ProfileStore);

export default appEnv;
